module.exports = __webpack_public_path__ + "img/consulting_home.fbed1a10.jpg";